import { render } from "./EditRoute.vue?vue&type=template&id=c4fdd4f2"
import script from "./EditRoute.vue?vue&type=script&lang=js"
export * from "./EditRoute.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__